import { FC } from 'react';
import { Tag } from './tag';
import styles from './index.module.scss';
import { Arrow } from '@/components/arrow';
import { useHover } from '@/hooks/useHover';
import { openLink } from '@web3/base-utils';
import { scTrack } from '@web3/base-tracking';
import { useScreenType } from '@web3/base-hooks';
import { Event, Page } from '@/config/track-config';

interface IProps {
  tagBgColor: string;
  tagTitle: string;
  tagColor?: string;
  title: string;
  desc: string;
  url: string;
  appUrl: string;
}

export const TokenCard: FC<IProps> = ({
  tagBgColor,
  tagTitle,
  tagColor,
  title,
  desc,
  url,
  appUrl,
}) => {
  const { active, bind } = useHover();
  const { isMobile } = useScreenType();

  return (
    <div
      className={styles.tokenCard}
      {...bind}
      onClick={() => {
        scTrack(Event.Web3UserClick, {
          page_name: Page.Home,
          area: 'Launches',
          button_name: tagTitle,
          params: isMobile ? appUrl : url,
        });
        if (isMobile) {
          if (appUrl) {
            openLink(appUrl);
          }
          return;
        }
        window.open(url);
      }}
    >
      <div className={styles.tokenCard_top}>
        <Tag bgColor={tagBgColor} title={tagTitle} color={tagColor} />
      </div>
      <div className={styles.tokenCard_middle}>
        <div className={styles.tokenCard_middle__title}>{title}</div>
        <div className={styles.tokenCard_middle__desc}>{desc}</div>
      </div>
      <div className={styles.tokenCard_bottom}>
        <div>
          <Arrow active={active} />
        </div>
      </div>
    </div>
  );
};
